import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { Switch, Select, InputNumber } from 'antd'
import styled from 'styled-components/macro'
import { Col } from 'styled-bootstrap-grid'
import { SelectValue } from 'antd/lib/select'
import { NavProps, WizardNavigationWrapper, WizardNav } from '../../../components/Wizard/WizardNav'
import { isValidating, getFlowValidationResult, selectedFlow } from '../../../features/flow/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { Label, CenteredRow } from '../../../components/Page/Layout'
import { Row } from '../../../components/Grid'
import { getHooks } from '../../../features/hook/selectors'
import { Hook } from '../../../features/hook/types'
import { FlowActions } from '../../../features/flow/actions'
import { SectionEnum } from './types'

const { Option } = Select

const StyledSelect = styled(Select)`
  width: 200px;
  /* margin-left: 12px; */
`

const ColumnWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-row-gap: 40px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  /* div {
    text-align: center;
  } */
  .ant-switch {
    margin-top: 6px;
    margin-bottom: 6px;
    margin-right: 10px;
  }
`

type AddFlowConfigurationProps = {
  addFlow: () => void
} & NavProps

export const AddFlowConfiguration: React.FC<AddFlowConfigurationProps> = ({
  addFlow,
  ...rest
}: AddFlowConfigurationProps) => {
  const dispatch = useDispatch()
  const loading = useSelector(isValidating)
  const status = useSelector(getFlowValidationResult)
  const flow = useSelector(selectedFlow)

  const hooks = useSelector(getHooks)

  const [isChatActive, setIsChatActive] = useState(false)
  const [isRadarActive, setIsRadarActive] = useState(false)
  const [isProfileActive, setIsProfileActive] = useState(false)

  useEffect(() => {
    setIsChatActive(flow?.chat?.enabled || false)
    setIsRadarActive(flow?.radar?.enabled || false)
    setIsProfileActive(flow?.profile?.enabled || false)
  }, [flow])

  function changeHandler(field: SectionEnum, data: any) {
    if (flow && flow.name) {
      const oldValue = flow[field]
      const flowToValidate = { ...flow, [field]: { ...oldValue, data: { ...oldValue?.data, ...data } } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
    }
  }

  function changeConfig(data: any) {
    if (flow && flow.name) {
      const oldValue = flow.config
      const flowToValidate = { ...flow, config: { ...oldValue, ...data } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
      console.log(flowToValidate, data)
    }
  }

  if (!flow) return <LoadingOverlay loading>&nbsp;</LoadingOverlay>

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Configurazione</CenteredRow>
        <Row>
          <Col md={8} mdOffset={2}>
            <ColumnWrapper>
              {!isChatActive ? null : (
                <>
                  <div>
                    <Label>Chat - Attiva Lettura</Label>
                    <Switch
                      checkedChildren={<span>Attiva</span>}
                      unCheckedChildren={<span>Disattiva</span>}
                      defaultChecked
                      checked={flow.chat?.data?.activeRead?.enabled}
                      onChange={(c: boolean) => {
                        changeHandler('chat', {
                          activeRead: { ...flow.chat?.data?.activeRead, enabled: c, hook: null }
                        })
                      }}
                    />
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeHandler('chat', {
                          activeRead: {
                            ...flow.chat?.data.activeRead,
                            hook: value
                          }
                        })
                      }}
                      value={flow?.chat?.data?.activeRead?.hook || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>Chat - Numero Messaggi</Label>
                    <InputNumber
                      min={0}
                      max={100}
                      value={flow.chat?.data?.availableMessages?.count || 0}
                      onChange={(c: any) => {
                        changeHandler('chat', {
                          availableMessages: { ...flow.chat?.data?.availableMessages, count: c }
                        })
                      }}
                    />
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeHandler('chat', {
                          availableMessages: {
                            ...flow.chat?.data.availableMessages,
                            hook: value
                          }
                        })
                      }}
                      value={flow?.chat?.data?.availableMessages?.hook || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>
                      Chat - Leggi Messaggio <small>( criptato )</small>
                    </Label>
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          readMessage: value
                        })
                      }}
                      value={flow.config?.readMessage || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                </>
              )}
              {!isRadarActive ? null : (
                <>
                  <div>
                    <Label>
                      Radar - pagine visibili <small>( 0 = infinite )</small>
                    </Label>
                    <InputNumber
                      min={0}
                      max={100}
                      value={flow?.config?.maxVisiblePage || 0}
                      onChange={(c: any) => {
                        changeConfig({ maxVisiblePage: c > 0 ? c : null })
                      }}
                    />
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          maxVisiblePageHook: value
                        })
                      }}
                      value={flow.config?.maxVisiblePageHook || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>
                      Radar - Profili bloccati <small>( per pagina )</small>
                    </Label>
                    <InputNumber
                      min={0}
                      max={12}
                      value={flow?.config?.lockedProfiles || 0}
                      onChange={(c: any) => {
                        changeConfig({ lockedProfiles: c > 0 ? c : null })
                      }}
                    />
                  </div>
                </>
              )}
              {!isProfileActive ? null : (
                <>
                  <div>
                    <Label>Profile - numero di like</Label>
                    <InputNumber
                      min={0}
                      max={100}
                      value={flow?.config?.counterLike || 0}
                      onChange={(c: any) => {
                        changeConfig({ counterLike: c > 0 ? c : null })
                      }}
                    />
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          counterLikeHook: value
                        })
                      }}
                      value={flow.config?.counterLikeHook || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>
                      Profile - Premium <small>( verifica identità )</small>
                    </Label>
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          verifyIdentity: value
                        })
                      }}
                      value={flow.config?.verifyIdentity || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>User Profile - Cambio Città</Label>
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          changeCity: value
                        })
                      }}
                      value={flow.config?.changeCity || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                  <div>
                    <Label>User Profile - Cambio Dati</Label>
                    <StyledSelect
                      onChange={(value: SelectValue) => {
                        changeConfig({
                          changeProfileData: value
                        })
                      }}
                      value={flow.config?.changeProfileData || ''}
                    >
                      {_.map(hooks, (h: Hook) => (
                        <Option key={h.id} value={h.id}>
                          {h.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </div>
                </>
              )}
            </ColumnWrapper>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid || loading} nextStep={addFlow} nextStepText="Salva" />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
